<template>
	<!-- 예제 : src\views\qms\Pqy\Partu\PartsInfo\Content\Search\Search.vue -->
	<div class="qms-search-input sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label" v-show="label">{{ label }}</span>
		<div class="search-option-wrapper__normal">
			<el-input
				:value="data"
				@input="val => inputData(val)"
				:placeholder="placeholder || label"
				:maxlength="maxLen"
				:clearable="clearable"
				:readonly="readonly"
				@keyup.native.enter="keyupEnter"
				v-bind="{ ...elObject }"
			></el-input>
			<span class="unit" style="top: 0px !important">
				<slot name="icon" v-if="!iconReadonly"></slot>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search-input',
	props: {
		label: { default: '' },
		paramKey: { default: '' }, //키 값
		placeholder: { default: '' },
		propData: { default: '' },
		maxLen: { default: 40 }, //길이제한
		clearable: { default: true }, //한번에 지우는 기능
		readonly: { default: false },
		iconReadonly: { default: false }, //아이콘 안나타나게
		filterReg: { default: '' }, //필터링할 정규식
		elProps: {
			type: Object,
			default: () => {},
			description: 'el-element에서 제공하는 props들 매핑할 수 있는 Props'
		}
	},
	data() {
		return {
			data: ''
		};
	},
	created() {
		this.data = this.propData;
	},
	watch: {
		propData() {
			this.data = this.propData;
		}
	},
	computed: {
		elObject() {
			return this.elProps;
		}
	},
	methods: {
		keyupEnter() {
			//enter 키 눌렀을 경우 발생하는 이벤트
			this.$emit('keyupEnter');
		},
		inputData(value) {
			if (this.filterReg) {
				value = value.replace(this.filterReg, '');
			}
			this.data = value;
			return this.$emit('commInput', { key: this.paramKey, value: this.data });
		}
	}
};
</script>

<style lang="scss" scoped>
.search-option-wrapper__normal {
	position: relative;
}
</style>
